<div class="page-content-wrapper">
  <div v-if="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div class="card shadow border-1 rounded-3">
    <div class="card-header bg-white border-0 me-2">
      <p class="text-s fw-bold">Services</p>
    </div>
    <div class="card-body">
      <CustomTabs :tabs="tabs" v-model="currentTab" />
      <div class="tab-content">
        <CustomTable
          :columns="columns"
          :fetchData="view_services_requested"
          :key="currentTab"
          :hasActions="currentTab === 'Pending' || currentTab === 'Declined'"
          :tableKey="`requested_services_${currentTab}`"
        >
          <template v-slot:cell-service_name="{ row }">
            {{ row.service_name }}
          </template>
          <template  v-slot:actions="{ row }">
            <button
              v-if="currentTab === 'Pending' || currentTab === 'Declined'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow me-2"
              @click="action_service_requested(row.service_id, row.application_id, 'approve')"
            >
              Approve
            </button>
            <button
              v-if="currentTab === 'Pending'"
              class="btn btn-danger btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="action_service_requested(row.service_id, row.application_id, 'decline')"
            >
              Decline
            </button>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</div>
